import { getStreamStatusHelpText, Stream } from 'types/stream';
import { useNavigate } from 'react-router-dom';

import { useDeleteStreams } from 'streams/hooks/useDeleteStreams';
import { useModal } from 'hooks/useModal';
import { useMqttStreamsState } from 'streams/hooks/useMqttStreamsState';

import { DetailViewStatus } from 'components/DetailView/DetailView';
import { IconButton } from 'components/IconButton/IconButtonDeprecated';
import { StatusIndicator } from 'components/StatusIndicator/StatusIndicator';

export type StreamDetailActionsProps = {
  stream: Stream;
  isEditable?: boolean;
  onRename?: () => void;
};

export function StreamDetailActions({
  stream,
  isEditable = true,
  onRename,
}: StreamDetailActionsProps) {
  const navigate = useNavigate();

  useMqttStreamsState([stream.id]);

  const { open } = useModal();

  const { mutateAsync: deleteStreams, isLoading } = useDeleteStreams({
    // Navigate to overview
    onMutate() {
      navigate('./..');
    },
  });

  function handleDeleteClick() {
    open('confirm-delete', {
      title: `Are you sure you want to delete ${stream.name}?`,
      onConfirm: () => deleteStreams({ stream_ids: [stream.id] }),
    });
  }

  return (
    <DetailViewStatus entity={stream} onRename={onRename}>
      <StatusIndicator
        status={stream.status}
        tooltip={getStreamStatusHelpText(stream)}
      />

      {isEditable && stream.source === 'uri_stream' && (
        <IconButton
          icon="delete"
          label="Delete"
          intent="danger"
          variant="secondary"
          onClick={handleDeleteClick}
          loading={isLoading}
          size="small"
          showLabel
        />
      )}
    </DetailViewStatus>
  );
}
